import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Field, Formik, Form } from 'formik';
import { useDispatch } from 'react-redux';
import Spinner from '../../../../../CommonComponents/Spinner';
import FormikInput from '../../../../../CommonComponents/FormikInput';
import FormikSelect from '../../../../../CommonComponents/FormikSelect';
import { PrimaryButton, SecondaryButton } from '../../../../../CommonComponents/Button';
import { usZipCodeMask } from '../../../../../CommonComponents/MaskedInput';
import FormikMaskedInput from '../../../../../CommonComponents/FormikMaskedInput';
import { updateAddress } from '../../../../ExperianActions';
import { Footer, Label, LabelText } from '../../../../components/EnrollForm/EnrollFormStyles';
import { Title } from '../../ReportStyles';
import { STATES } from '../../../../components/EnrollForm/EnrollFormConstants';
import ExperianContext from '../../../../ExperianContext';

const AddressForm = ({ data, onCancel }) => {
  const { clientId, subscriberId } = useContext(ExperianContext);

  const dispatch = useDispatch();

  return (
    <Formik
      initialValues={{
        address1: data.Address1,
        address2: data.Address2,
        city: data.City,
        state: data.State,
        zip: data.ZipCode,
      }}
      onSubmit={async (values, actions) => {
        try {
          await dispatch(updateAddress(clientId, subscriberId, values));
          onCancel();
        } catch {
          // Keep the modal open to display the error
        } finally {
          actions.setSubmitting(false);
        }
      }}
      render={({ isSubmitting }) => (
        <Form>
          {isSubmitting && <Spinner />}
          <Title>Edit Address</Title>
          <Label>
            <LabelText>Address</LabelText>
            <Field type="text" name="address1" component={FormikInput} size="small" />
          </Label>
          <Label>
            <Field type="text" name="address2" component={FormikInput} size="small" />
          </Label>
          <Label>
            <LabelText>City</LabelText>
            <Field type="text" name="city" component={FormikInput} size="small" />
          </Label>
          <Label>
            <LabelText>State</LabelText>
            <Field
              type="text"
              name="state"
              component={FormikSelect}
              options={STATES}
              size="small"
            />
          </Label>
          <Label>
            <LabelText>Zip</LabelText>
            <Field
              type="text"
              name="zip"
              mask={usZipCodeMask}
              component={FormikMaskedInput}
              size="small"
            />
          </Label>
          <Footer>
            <SecondaryButton onClick={onCancel}>Cancel</SecondaryButton>
            <PrimaryButton type="submit" disabled={isSubmitting}>
              Submit
            </PrimaryButton>
          </Footer>
        </Form>
      )}
    />
  );
};

AddressForm.propTypes = {
  data: PropTypes.shape({
    Address1: PropTypes.string,
    Address2: PropTypes.string,
    City: PropTypes.string,
    State: PropTypes.string,
    ZipCode: PropTypes.string,
  }).isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default AddressForm;
